import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventory-itinerary',
  templateUrl: './inventory-itinerary.component.html',
  styleUrls: ['./inventory-itinerary.component.scss'],
})
export class InventoryItineraryComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
